// Copyright (c) StrangeBee 2023

import { useLocalMessage } from '@Helpers/';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';
import { THForm } from '@Molecules/THForm/THForm';
import React, { ReactElement, useMemo } from 'react';

const IntervalField = (): ReactElement => {
    const i = useLocalMessage();

    const intervals = useMemo(
        () => [
            { value: '1d', label: i('dashboard.interval.day') },
            { value: '1w', label: i('dashboard.interval.week') },
            { value: '1M', label: i('dashboard.interval.month') },
            { value: '1y', label: i('dashboard.interval.year') },
        ],
        [i],
    );

    return (
        <THForm.Item
            name="interval"
            label={i('app.dashboard.widget.create.form.interval.label')}
            rules={[{ required: true, message: i('app.dashboard.widget.create.form.interval.required') }]}
        >
            <THSelect placeholder={i('app.dashboard.widget.create.form.interval.placeholder')} options={intervals} />
        </THForm.Item>
    );
};

export default IntervalField;
